{
  "nav": {
    "home": "Accueil",
    "tutorials": "Tutoriels",
    "contact": "Nous contacter",
    "logout": "Déconnexion",
    "logoAlt": "DinLabel",
    "download": "Télécharger",
    "buy": "Acheter",
    "login": "Connexion",
    "myAccount": "Mon compte",
    "settings": "Paramètres",
    "distributorPortal": "Portail distributeurs"
  },
  "settings": {
    "title": "Paramètres",
    "language": "Langue",
    "languageDescription": "Choisissez la langue de l'application. Par défaut, la langue du navigateur est utilisée.",
    "languageBrowser": "Utiliser la langue du navigateur",
    "languageEnglish": "Anglais",
    "languageSpanish": "Espagnol",
    "languageGerman": "Allemand",
    "languageFrench": "Français"
  },
  "offline": {
    "title": "Hors ligne",
    "message": "L'application ne peut pas se connecter au serveur :( !!"
  },
  "dialogs": {
    "apiError": "Erreur API",
    "confirmYes": "Oui",
    "cancel": "Annuler",
    "send": "Envoyer"
  },
  "portal": {
    "pageTitle": "Portail distributeurs",
    "actions": "Actions",
    "authorized": "Autorisé",
    "pending": "En attente d'approbation",
    "buyLicenses": "Acheter des licences",
    "pendingApproval": "Votre demande de distributeur n'a pas encore été approuvée – pour toute question, vous pouvez contacter {{email}}. Ce processus ne devrait pas prendre plus de 2 jours ouvrables.",
    "distributorInfo": "Informations pour les distributeurs",
    "loading": "Chargement des informations du distributeur…",
    "loadError": "Impossible de charger les informations du distributeur."
  },
  "licenses": {
    "noneAvailable": "Vous n'avez actuellement aucune licence disponible à envoyer.",
    "availableCount": "Vous avez {{count}} licences disponibles à envoyer.",
    "boughtAndSent": "Au total, vous avez acheté {{bought}} licences et envoyé {{sent}} licences",
    "statAvailable": "Disponibles à envoyer",
    "statBought": "Achetées",
    "statSent": "Envoyées",
    "sentHistory": "Licences envoyées",
    "activatedYes": "Activée",
    "buyTitle": "Portail distributeurs - Acheter des licences",
    "buyLoading": "Chargement…",
    "buyLoadError": "Impossible de charger les informations du distributeur.",
    "buyIntro": "Indiquez le nombre de licences que vous souhaitez acheter – le prix distributeur est de {{price}} pesos. Les distributeurs peuvent vendre DinLabel comme ils le jugent approprié, mais notre prix recommandé est de {{recommended}} pesos.",
    "licenseCountLabel": "Nombre de licences",
    "costSummary": "Le coût de {{count}} licences est de {{cost}} pesos + taxes.",
    "buyButton": "Acheter {{count}} licences",
    "sendTitle": "Envoyer une licence",
    "resendConfirm": "Voulez-vous renvoyer la licence à {{email}} ?",
    "sendPrompt": "Entrez l'e-mail auquel vous souhaitez envoyer",
    "emailPlaceholder": "email@exemple.com",
    "errorTitle": "Erreur !",
    "sendError": "Une erreur s'est produite lors de l'envoi de la licence {{error}}",
    "resentTitle": "Licence renvoyée !",
    "resentMessage": "La licence a été renvoyée à {{email}} avec copie à {{cc}}",
    "sentTitle": "Licence envoyée !",
    "sentMessage": "La licence a été envoyée à {{email}} avec copie à {{cc}}",
    "sendToEmail": "Envoyer la licence par e-mail...",
    "recipient": "Destinataire de la licence",
    "date": "Date",
    "sent": "Envoyée",
    "activated": "Activée",
    "notActivated": "Pas encore activée",
    "resend": "Renvoyer la licence"
  },
  "register": {
    "title": "Devenir distributeur",
    "intro": "Pour accéder au portail distributeurs DinLabel, vous devez d'abord vous inscrire :",
    "company": "Entreprise",
    "companyPlaceholder": "Nom de l'entreprise",
    "phone": "Téléphone",
    "phonePlaceholder": "Téléphone",
    "phoneDescription": "Assurez-vous d'inclure l'indicatif du pays, par exemple +33 1...",
    "street": "Rue",
    "street1Placeholder": "Rue 1",
    "street2Placeholder": "Rue 2",
    "number": "Numéro",
    "city": "Ville",
    "state": "Région",
    "country": "Pays",
    "zip": "Code postal",
    "rfc": "Identifiant fiscal",
    "nextSteps": "Vous recevrez un e-mail avec les prochaines étapes",
    "submit": "Envoyer"
  },
  "faq": {
    "qGoogleAccount": "Ai-je besoin d'un compte Google pour être distributeur DINLabel ?",
    "aGoogleAccount": "Oui, vous avez besoin d'un compte Google. Si vous en avez déjà un, vous pouvez l'utiliser pour vous connecter au portail distributeurs.",
    "qRequirements": "Que dois-je faire pour devenir distributeur DINLabel ?",
    "aRequirementsBefore": "Inscrivez-vous en tant que distributeur dans le",
    "aRequirementsLink": "portail distributeurs",
    "aRequirementsAfter": "et attendez de recevoir l'e-mail de confirmation vous autorisant en tant que distributeur DINLabel.",
    "qAnyoneCanSell": "Toute personne ou entreprise peut-elle vendre DINLabel ?",
    "aAnyoneCanSell": "Oui, il suffit de s'inscrire sur le portail distributeurs DINLabel et de recevoir l'e-mail de confirmation.",
    "qHowManyDistributors": "Combien de distributeurs peut-il y avoir chez DINLabel ?",
    "aHowManyDistributors": "Il n'y a pas de limite.",
    "qDistributorCost": "Combien coûte une licence DINLabel pour un distributeur ?",
    "aDistributorCost": "112 USD plus taxes par licence.",
    "qRecommendedPrice": "Quel est le prix de vente recommandé du distributeur à ses clients pour une licence DINLabel ?",
    "aRecommendedPrice": "Le distributeur fixe le prix ; il n'y a pas de prix fixe. Nous suggérons un prix de vente de 160 USD plus taxes. Le prix direct sur le portail DINLabel sans distributeur est de 180 USD.",
    "qWhereToBuy": "Où un utilisateur final peut-il acheter une licence DINLabel ?",
    "aWhereToBuyBefore": "Il peut l'acheter auprès d'un distributeur ou directement sur le portail",
    "qHowBuyAsDistributor": "En tant que distributeur, comment acheter des licences DINLabel ?",
    "aHowBuyAsDistributorBefore": "Via le portail distributeurs, en allant dans la section Acheter des licences. Voir le tutoriel",
    "aHowBuyAsDistributorLink": "comment acheter des licences.",
    "qMinimumLicenses": "En tant que distributeur, lors de l'achat de licences pour les revendre à mes clients, quel est le nombre minimum de licences à acheter ?",
    "aMinimumLicenses": "Il n'y a pas de minimum ; vous pouvez acheter à partir de 1 licence.",
    "qHowDeliver": "En tant que distributeur, comment livrer une licence DINLabel à mon client ?",
    "aHowDeliverBefore": "Via le portail distributeurs, dans la section",
    "aHowDeliverSendLink": "envoyer des licences",
    "aHowDeliverMiddle": " ; voir le",
    "aHowDeliverTutorialLink": "tutoriel sur l'envoi de licences.",
    "qHowLongPurchase": "Combien de temps faut-il pour acheter une licence en tant que distributeur et la livrer au client ?",
    "aHowLongPurchase": "Si vous êtes déjà enregistré en tant que distributeur, l'achat et la livraison de la licence peuvent se faire en quelques minutes.",
    "qHowLongToSell": "En tant que distributeur, combien de temps ai-je pour vendre les licences achetées sur le portail ?",
    "aHowLongToSell": "Les licences distributeur n'expirent pas. Lorsque vous achetez des licences, elles sont ajoutées à votre inventaire et vous pouvez les utiliser à tout moment.",
    "qHowManyAvailable": "Comment savoir combien de licences j'ai en tant que distributeur ?",
    "aHowManyAvailableBefore": "Lorsque vous entrez dans le",
    "aHowManyAvailableLink": "portail distributeurs",
    "aHowManyAvailableAfter": " DINLabel, le premier écran affiche votre solde de licences disponibles à envoyer.",
    "qSoldLicenses": "Comment savoir quelles licences j'ai vendues et à qui ?",
    "aSoldLicensesBefore": "Via le portail distributeurs DINLabel dans la section",
    "aSoldLicensesLink": "voir les détails",
    "qTryBefore": "Puis-je essayer DINLabel avant de devenir distributeur ?",
    "aTryBeforeBefore": "Oui, vous pouvez télécharger une démo sur",
    "aTryBeforeAfter": "et l'essayer.",
    "qMainFaq": "Y a-t-il des FAQ (foire aux questions) sur le portail DINLabel ?",
    "aMainFaqBefore": "Sur",
    "aMainFaqAfter": "vous trouverez les questions les plus fréquentes sur l'utilisation du système DINLabel.",
    "qTutorials": "Y a-t-il des tutoriels pour utiliser DINLabel ?",
    "aTutorialsBefore": "Sur",
    "aTutorialsAfter": "vous trouverez tous les tutoriels nécessaires pour utiliser DINLabel.",
    "qSupport": "En tant que distributeur, ai-je un support technique ?",
    "aSupport": "Par e-mail ; voir la fin de cette FAQ.",
    "qOtherQuestion": "J'ai une question qui n'est pas dans la liste. Que puis-je faire ?",
    "aOtherQuestionBefore": "Nous serions ravis de vous aider. Allez à",
    "aOtherQuestionLink": "nous contacter",
    "aOtherQuestionAfter": ", envoyez vos questions, et nous vous répondrons volontiers."
  },
  "tutorials": {
    "title": "Tutoriels",
    "alsoSeeFaqBefore": "Vous pouvez aussi consulter la",
    "alsoSeeFaqLink": "FAQ",
    "sendLicenseTutorial": "Tutoriel : Comment envoyer une licence depuis le portail distributeurs",
    "iframeTitle": "Tutoriel envoi de licence"
  },
  "home": {
    "welcome": "Bienvenue, {{email}}",
    "error": "Erreur"
  },
  "userLicenses": {
    "hasLicense": "Vous avez déjà une licence DinLabel.",
    "noLicense": "Vous n'avez pas encore acheté votre licence DinLabel",
    "buyHere": "L'acheter ici"
  },
  "app": {
    "documentTitle": "DinLabel"
  },
  "signin": {
    "title": "Connexion",
    "intro": "Connectez-vous avec votre compte Google pour continuer.",
    "withGoogle": "Se connecter avec Google",
    "agreePrefix": "En continuant, vous acceptez notre",
    "privacyLink": "Politique de confidentialité et conditions d'utilisation",
    "alreadySignedIn": "Vous êtes déjà connecté",
    "signedInAs": "Connecté en tant que {{email}}",
    "continue": "Continuer",
    "debugSignInUrl": "URL de connexion"
  },
  "applogin": {
    "title": "Continuer dans DinLabel",
    "intro": "Continuez pour terminer la connexion à l'application de bureau.",
    "signedInAs": "Vous êtes connecté en tant que {{email}}.",
    "continue": "Continuer",
    "switchAccount": "Utiliser un autre compte",
    "redirecting": "Redirection vers la connexion…",
    "invalidTitle": "Lien de connexion non valide",
    "invalidBody": "Cette page est ouverte par l'application de bureau DinLabel. Veuillez démarrer la connexion depuis l'application."
  },
  "marketing": {
    "headline": "Logiciel professionnel de conception d'étiquettes",
    "slogan": "Concevez et imprimez des étiquettes sur imprimantes thermiques — Zebra et plus — avec codes-barres, données variables et numéros en série.",
    "featureNumbers": "Numéros en série",
    "featureImages": "Images",
    "featureVariable": "Données variables",
    "featureQr": "Code-barres 2D",
    "featureText": "Texte",
    "featureBarcode": "Code-barres",
    "featuresTitle": "Tout ce dont vous avez besoin sur une étiquette",
    "featuresSubtitle": "Créez des étiquettes professionnelles avec les outils sur lesquels s'appuient les imprimeries et les entrepôts chaque jour.",
    "printersTitle": "Conçu pour les imprimantes d'étiquettes thermiques",
    "printersSubtitle": "DinLabel fonctionne avec les imprimantes thermiques et industrielles déjà utilisées en atelier — notamment Zebra, Honeywell, TSC, SATO et d'autres imprimantes d'étiquettes compatibles Windows.",
    "printersBrands": "Zebra · Honeywell · TSC · SATO · et plus",
    "printersNote": "Imprimez sur des imprimantes thermiques de bureau et industrielles via vos pilotes Windows habituels. Idéal pour rouleaux, planches, étiquettes d'expédition et lignes de production.",
    "whyTitle": "Pourquoi DinLabel ?",
    "whyBody": "DinLabel vous aide à créer rapidement des étiquettes professionnelles pour imprimantes thermiques, rouleaux, planches et équipements industriels — sans les prix des logiciels d'entreprise.",
    "tryTitle": "Essayez la démo DinLabel",
    "trySubtitle": "Téléchargez la démo, connectez votre imprimante thermique et commencez à concevoir des étiquettes en quelques minutes.",
    "needHelp": "Besoin d'aide ?",
    "customerService": "Service client",
    "customerServiceText": "Contactez-nous par e-mail et nous vous aiderons volontiers.",
    "tutorialsText": "Tutoriels vidéo étape par étape pour chaque fonctionnalité."
  },
  "footer": {
    "tagline": "Conception professionnelle d'étiquettes pour imprimantes thermiques — Zebra et plus.",
    "privacy": "Confidentialité et conditions",
    "copyright": "© {{year}} DinLabel"
  },
  "install": {
    "title": "Télécharger",
    "intro": "Installez DinLabel sur Windows et commencez à concevoir des étiquettes pour imprimantes thermiques — notamment Zebra et d'autres imprimantes d'étiquettes Windows — en quelques minutes.",
    "windowsNote": "Installateur Windows (.exe). Compatible avec Windows 7 et versions ultérieures.",
    "requirements": "Configuration requise",
    "reqWindows": "Toute version de Windows à partir de Windows 7",
    "reqInternet": "Accès Internet",
    "reqRam": "1 Go de RAM",
    "reqDisk": "10 Go d'espace disque dur",
    "freeTag": "Version démo",
    "freeText": "La version démo inclut un filigrane sur les étiquettes imprimées.",
    "paidTitle": "Version complète",
    "paidText": "Sans filigranes — prête pour l'impression de production.",
    "buyApp": "Acheter l'application",
    "orDistributor": "Vous préférez acheter via un partenaire ?",
    "distributorsLink": "Voir les distributeurs",
    "emailModalTitle": "Télécharger la démo",
    "emailModalIntro": "Entrez votre adresse e-mail pour télécharger la démo DinLabel.",
    "emailLabel": "E-mail",
    "emailSubmit": "Télécharger",
    "emailInvalid": "Veuillez saisir une adresse e-mail valide.",
    "emailSubmitError": "Une erreur s'est produite. Veuillez réessayer.",
    "purchasedIntro": "Téléchargez et installez DinLabel pour commencer à utiliser votre version complète.",
    "signInTitle": "Comment se connecter",
    "signInStep1": "Téléchargez et installez DinLabel à l'aide du bouton ci-dessus.",
    "signInStep2": "Ouvrez DinLabel.",
    "signInStep3": "Choisissez Se connecter / S'inscrire dans le menu.",
    "signInStep4": "Connectez-vous avec le même compte Google que celui utilisé pour l'achat. Une fois connecté, vous utiliserez la version complète de DinLabel."
  },
  "fullTutorials": {
    "title": "Tutoriels",
    "intro": "Vidéos étape par étape pour vous aider à concevoir, imprimer et tirer le meilleur parti de DinLabel.",
    "howToRoll": "Comment créer une étiquette sur rouleau",
    "howToSheet": "Comment créer une étiquette sur planche",
    "howTo3Across": "Comment créer des étiquettes 3 de front",
    "howToText": "Comment ajouter du texte",
    "howToShapes": "Comment ajouter des formes",
    "howToImages": "Comment ajouter des images",
    "howToBarCodes": "Comment ajouter des codes-barres",
    "howToQR": "Comment ajouter des codes QR",
    "howToPrint": "Comment imprimer",
    "howToConsecutive": "Comment utiliser les numéros consécutifs",
    "howToDataBase": "Comment utiliser les bases de données",
    "howToBuy": "Comment acheter DinLabel",
    "alsoDistributor": "Des tutoriels spécifiques aux distributeurs sont disponibles dans le portail distributeurs.",
    "distributorLink": "Ouvrir le portail distributeurs"
  },
  "privacy": {
    "title": "Politique de confidentialité et conditions d'utilisation",
    "eulaLink": "Contrat de licence utilisateur final",
    "policyLink": "Politique de confidentialité",
    "note": "La politique de confidentialité ouvre le document HTML statique localisé.",
    "loading": "Chargement…",
    "eulaLoadError": "Impossible de charger le CLUF."
  },
  "distributors": {
    "title": "Distributeurs"
  },
  "buyPage": {
    "title": "Acheter DinLabel",
    "intro": "Débloquez la version complète — sans filigranes, prête pour l'impression thermique et de production sur Zebra et d'autres imprimantes d'étiquettes.",
    "panelTitle": "Version complète",
    "loading": "Chargement du paiement…",
    "loadError": "Impossible de démarrer le paiement. Veuillez vous connecter et réessayer.",
    "errorTitle": "Une erreur s'est produite",
    "thanks": "Merci d'avoir acheté DinLabel. Vous avez maintenant un accès complet à l'application !",
    "checkAccount": "Vérifier l'état de votre compte",
    "goToDownload": "Aller à la page de téléchargement",
    "price": "USD ${{price}} + Taxes",
    "payWithCard": "Payer par carte",
    "payError": "Impossible de rediriger vers le paiement Stripe.",
    "adminTestMode": "Ceci est un utilisateur admin, le paiement utilisera donc le mode test. Utilisez la carte '4242 4242 4242 4242'.",
    "debugToggleBought": "Réservé aux admins : Debug : Basculer Bought",
    "toggleBoughtError": "Impossible de basculer l'état d'achat.",
    "orVia": "Vous préférez une autre option ?",
    "downloadDemo": "Télécharger une démo entièrement fonctionnelle",
    "contactDistributor": "Contacter un distributeur",
    "becomeDistributor": "Vous souhaitez devenir distributeur ?"
  },
  "userInfo": {
    "title": "Mon compte",
    "detailsTitle": "Détails du compte",
    "quickLinks": "Liens rapides",
    "userId": "ID utilisateur",
    "email": "Adresse e-mail",
    "emailConfirmed": "E-mail confirmé",
    "confirmed": "Confirmé",
    "notConfirmed": "Non confirmé",
    "resend": "Renvoyer",
    "resentEmail": "E-mail de confirmation renvoyé à {{email}}",
    "resendError": "Impossible de renvoyer l'e-mail de confirmation.",
    "version": "Version de l'application",
    "freeVersion": "Version démo",
    "fullVersion": "Version complète",
    "buyApp": "Acheter l'application",
    "accountType": "Compte",
    "admin": "Portail d'administration",
    "openDistributorPortal": "Ouvrir le portail distributeurs"
  },
  "myLabels": {
    "title": "Mes étiquettes",
    "loading": "Chargement…",
    "loadError": "Impossible de charger les étiquettes.",
    "empty": "Vous n'avez aucune étiquette enregistrée.",
    "name": "Nom",
    "date": "Date",
    "view": "Voir",
    "download": "Télécharger",
    "back": "Retour à mes étiquettes"
  },
  "admin": {
    "title": "Portail d'administration",
    "dataLink": "Tableau de bord d'analyse client DinLabel",
    "serverAnalyticsLink": "Tableau de bord d'analyse serveur",
    "fakeEmailLink": "E-mails fictifs",
    "loading": "Chargement…",
    "loadError": "Impossible de charger les données d'administration.",
    "totalUsers": "Utilisateurs totaux : {{count}}",
    "paidUsers": "Utilisateurs payants : {{count}}",
    "users": "Utilisateurs",
    "distributors": "Distributeurs",
    "payments": "Paiements distributeurs",
    "demoDownloaders": "Téléchargements démo",
    "authorize": "Autoriser"
  },
  "fakeEmail": {
    "title": "E-mails fictifs",
    "description": "Aperçu des modèles d'e-mail avec des données fictives.",
    "distributorSignUp": "Inscription distributeur",
    "activationLink": "Activation / confirmation d'e-mail",
    "sendEmailLicense": "Envoi de licence par le distributeur",
    "congratulationEmail": "Félicitations",
    "boughtLicensesMail": "Licences achetées",
    "demoDownloadThankYou": "Remerciement téléchargement démo",
    "subject": "Objet",
    "body": "Corps",
    "loading": "Chargement…",
    "loadError": "Impossible de charger cet e-mail.",
    "backAdmin": "Retour à l'administration",
    "testAddress": "Adresse de test",
    "testAddressPlaceholder": "vous@exemple.com",
    "sendTest": "Envoyer un test",
    "sendSuccess": "{{action}} envoyé à {{email}}",
    "sendError": "Échec de l'envoi de l'e-mail de test."
  }
}
